import React from 'react';

import { token } from '@atlaskit/tokens';

export const NoVerifiedAgentsIllustration = ({
	style,
}: {
	style: React.CSSProperties;
}): React.JSX.Element => (
	<svg
		width="175"
		height="160"
		viewBox="10 17 178 160"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
		style={style}
	>
		<path
			fill="#FCA700"
			fillRule="evenodd"
			d="M49.467 73v97.542l28.25-24.221h84.794V73H49.467Z"
			clipRule="evenodd"
		/>
		<circle cx="164" cy="107" r="17" fill="white" />
		<path
			fill="#0065FF"
			fillRule="evenodd"
			d="M154.041 85.329a5.1 5.1 0 0 1 6.619-1.774l4.106 2.112c.147.075.317.09.474.041l4.412-1.365a5.097 5.097 0 0 1 6.208 2.893l1.788 4.259a.638.638 0 0 0 .34.336l4.257 1.789a5.1 5.1 0 0 1 2.895 6.21l-1.368 4.409a.63.63 0 0 0 .044.476l2.111 4.106a5.1 5.1 0 0 1-1.775 6.619l-3.882 2.5a.643.643 0 0 0-.274.393l-1.021 4.503a5.098 5.098 0 0 1-5.611 3.929l-4.581-.581a.635.635 0 0 0-.463.124l-3.676 2.794a5.1 5.1 0 0 1-6.825-.598l-3.135-3.389a.642.642 0 0 0-.437-.202l-4.611-.224a5.099 5.099 0 0 1-4.844-4.846l-.225-4.611a.633.633 0 0 0-.2-.434l-3.389-3.134a5.1 5.1 0 0 1-.598-6.827l2.792-3.677a.63.63 0 0 0 .126-.461l-.58-4.582a5.097 5.097 0 0 1 3.93-5.61l4.502-1.023a.635.635 0 0 0 .391-.274l2.5-3.881Zm6.944 27.063-7.312-5.157-2.573 3.652 9.501 6.701a2.238 2.238 0 0 0 3.314-.888l9.756-21.108-4.054-1.876-8.632 18.676Z"
			clipRule="evenodd"
		/>
		<g clipPath="url(#a)">
			<path
				fill={token('color.text')}
				d="M12.146 75.077c-.698-.141-1.755 1.73-1.275 2.255.68.75 1.48 1.397 2.602 2.044 1.333.635 1.87.43 2.71.961 1.468.827 3.653 2.743 4.178 3.21.077.071.16.123.256.167.673.289 3.602 1.57 5.915 3.05 1.692.949 2.736 1.532 3.28 1.84 1.295.71 2.365 1.063 3.512 1.243.628.096 1.544-1.525 1.134-2.012-.743-.891-1.595-1.622-2.877-2.365-.5-.282-1.288-1.32-2.717-2.224a2.4 2.4 0 0 0-.769-.313c-2.396-.552-4.96-2.224-4.96-2.224l-5.645-3.197c-1.268-.705-1.877-1.051-2.249-1.256-1.14-.628-2.101-.974-3.095-1.167v-.012ZM34.772 46.716c-.5-.218-2.012 1.307-1.897 1.768.186.66.449 1.243.936 1.897.621.686 1.128.634 1.442 1.211.608.923 1.025 2.87 1.121 3.358.013.07.045.134.09.185.327.391 1.634 2.166 2.665 3.928.212.295.404.558.577.795.192.23.359.442.506.622.289.371.545.621.705.8.788.834 1.628 1.237 2.518 1.398.5.096 1.526-1.461 1.372-1.865-.308-.737-.66-1.307-1.256-1.987-.116-.128-.218-.403-.327-.775-.122-.359-.27-.788-.532-1.243a1.245 1.245 0 0 0-.371-.359c-.699-.423-1.276-1.115-1.66-1.71a8.953 8.953 0 0 1-.602-1.07s-.385-.686-.853-1.513c-.48-.84-1.063-1.826-1.454-2.403-.564-.871-.904-1.275-1.077-1.525-.59-.75-1.204-1.211-1.916-1.506l.013-.006ZM57.513 23.808c-.41-.603-2.467 0-2.486.73-.026 1.032.102 2.07.461 3.345.519 1.416 1.057 1.647 1.294 2.64.487 1.653.737 4.607.795 5.319a.981.981 0 0 0 .07.3c.289.686 1.519 3.717 2.166 6.447.564 1.897.916 3.07 1.096 3.678.442 1.442.974 2.467 1.679 3.41.384.518 2.178-.007 2.217-.654.077-1.18-.032-2.32-.442-3.775-.167-.564-.02-1.884-.423-3.563a2.515 2.515 0 0 0-.333-.775c-1.352-2.108-2.044-5.164-2.044-5.164s-1.314-4.473-1.865-6.363a480.095 480.095 0 0 0-.756-2.525c-.391-1.269-.846-2.21-1.43-3.063v.013Z"
			/>
		</g>
		<defs>
			<clipPath id="a">
				<path d="M10.68 23.36h54.229v66.486h-54.23z" />
			</clipPath>
		</defs>
	</svg>
);
